import React from "react";
import PropTypes from "prop-types";
import "./style.scss";


const RecentAchievements = (props) => {

    return <div className="recentAchievementsContainer">
            <h3 className="title">Recent Achievements 
            <a onClick={props.navigateToAll} className="seeAllAchievements">
                <i className="ion-ios-arrow-forward"/>
            </a>
            </h3>
            <div className="achievementsList">
            {props.achievements && props.achievements.map((item) => {
                return <div className="achievement" key={item.type}>
                    <p className="achievementIcon"></p>
                    <p className="achievementName">{item.type}</p>
                </div>
            })}
            </div>
        </div>
}

RecentAchievements.propTypes = {
    achievements: PropTypes.array,
    navigateToAll: PropTypes.func
}

export default RecentAchievements;